module.exports = __webpack_public_path__ + "img/gf.eb540a33.svg";